import React, { useState } from 'react';

export const slugify = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const industriesData = [
  {
    title: 'Automotive',
    icon: 'fa-solid fa-car',
    description: 'Accelerate connected vehicle platforms, EV innovation, and smart manufacturing across the automotive value chain.',
    challenges: [
      'Shifting from hardware-centric to software-defined vehicle architectures',
      'Building resilient, real-time supply chains',
      'Delivering connected, AI-powered customer experiences',
    ],
    solutions: [
      'On-demand engineers for software-defined vehicle and embedded platforms',
      'Cloud and IoT specialists for connected vehicle data pipelines',
      'AI/ML developers for predictive maintenance and customer analytics',
    ],
  },
  {
    title: 'Banking and Financial Services',
    icon: 'fa-solid fa-building-columns',
    description: 'Modernize core banking, payments, and risk platforms with secure, compliant digital solutions.',
    challenges: [
      'Modernizing legacy core banking and payment systems',
      'Meeting strict security and regulatory compliance requirements',
      'Delivering seamless digital and omnichannel banking experiences',
    ],
    solutions: [
      'Backend and API developers for core banking modernization',
      'Cloud engineers for secure, scalable payment infrastructure',
      'Data engineers for fraud detection and compliance analytics',
    ],
  },
  {
    title: 'Education and Research',
    icon: 'fa-solid fa-graduation-cap',
    description: 'Empower institutions with digital learning platforms, research data systems, and student experience tools.',
    challenges: [
      'Supporting hybrid and remote learning at scale',
      'Securing student data and campus networks',
      'Modernizing legacy administrative systems',
    ],
    solutions: [
      'Full-stack developers for LMS and student portal platforms',
      'Cloud and DevOps engineers for scalable campus infrastructure',
      'Data specialists for learning and research analytics',
    ],
  },
  {
    title: 'Energy, Utilities and Natural Resources',
    icon: 'fa-solid fa-bolt',
    description: 'Optimize grid operations, sustainability initiatives, and resource management with data-driven platforms.',
    challenges: [
      'Digitizing operations across the energy value chain',
      'Meeting sustainability and ESG reporting requirements',
      'Optimizing asset performance and predictive maintenance',
    ],
    solutions: [
      'IoT and data engineers for smart grid and asset monitoring',
      'Cloud developers for trading and operations platforms',
      'AI specialists for predictive maintenance models',
    ],
  },
  {
    title: 'Healthcare',
    icon: 'fa-solid fa-heart-pulse',
    description: 'Improve patient outcomes with secure health data platforms, telehealth solutions, and clinical workflow automation.',
    challenges: [
      'Modernizing clinical and administrative systems while staying compliant',
      'Improving patient engagement and care coordination',
      'Securing sensitive health data across the care ecosystem',
    ],
    solutions: [
      'Developers experienced in HIPAA-compliant application development',
      'Cloud engineers for interoperable health data platforms',
      'AI/ML specialists for clinical decision-support tools',
    ],
  },
  {
    title: 'Insurance',
    icon: 'fa-solid fa-shield-halved',
    description: 'Streamline underwriting, claims, and policy management with intelligent automation and analytics.',
    challenges: [
      'Modernizing legacy policy and claims systems',
      'Speeding up underwriting and claims processing',
      'Strengthening data security and regulatory compliance',
    ],
    solutions: [
      'Backend developers for claims and policy management modernization',
      'AI/ML engineers for automated underwriting and fraud detection',
      'Cloud specialists for secure, scalable insurance platforms',
    ],
  },
  {
    title: 'Life Sciences',
    icon: 'fa-solid fa-dna',
    description: 'Speed up research, clinical trials, and regulatory compliance with scalable data and AI solutions.',
    challenges: [
      'Accelerating clinical trials while maintaining regulatory compliance',
      'Managing complex research and manufacturing data',
      'Protecting sensitive research data from cyber threats',
    ],
    solutions: [
      'Data engineers for research and real-world evidence platforms',
      'Cloud developers for regulatory-compliant infrastructure',
      'AI specialists for clinical trial data analysis',
    ],
  },
  {
    title: 'Manufacturing',
    icon: 'fa-solid fa-industry',
    description: 'Drive smart factory initiatives, supply chain visibility, and predictive maintenance with IoT and analytics.',
    challenges: [
      'Modernizing legacy plant and ERP systems',
      'Bridging operational technology (OT) and IT systems',
      'Improving supply chain visibility and predictive maintenance',
    ],
    solutions: [
      'IoT and data engineers for smart factory initiatives',
      'DevOps specialists for OT/IT integration',
      'ML engineers for predictive maintenance and quality analytics',
    ],
  },
  {
    title: 'Private Equity',
    icon: 'fa-solid fa-chart-pie',
    description: 'Enable data-driven due diligence, portfolio monitoring, and value creation with tailored technology solutions.',
    challenges: [
      'Executing carve-outs and post-acquisition IT integrations',
      'Modernizing portfolio company technology stacks',
      'Reducing operational costs across the portfolio',
    ],
    solutions: [
      'On-demand developers for rapid platform migrations',
      'Cloud and DevOps engineers for infrastructure separation and integration',
      'Data specialists for portfolio performance analytics',
    ],
  },
  {
    title: 'Public Sector and Education',
    icon: 'fa-solid fa-landmark',
    description: 'Support government agencies and educational institutions with secure, citizen-centric digital services.',
    challenges: [
      'Modernizing legacy government systems',
      'Protecting citizen data and meeting compliance requirements',
      'Improving digital service delivery and accessibility',
    ],
    solutions: [
      'Full-stack developers for citizen-facing digital services',
      'Cloud and security engineers for compliant infrastructure',
      'Data specialists for service optimization analytics',
    ],
  },
  {
    title: 'Retail and Consumer Packaged Goods',
    icon: 'fa-solid fa-bag-shopping',
    description: 'Deliver personalized shopping experiences and resilient supply chains with omnichannel retail technology.',
    challenges: [
      'Delivering personalized, omnichannel shopping experiences',
      'Managing complex inventory and supply chains',
      'Competing with fast-moving digital-first retailers',
    ],
    solutions: [
      'Ecommerce and Shopify developers for storefront and app development',
      'Backend engineers for inventory and supply chain systems',
      'AI/ML specialists for personalization and demand forecasting',
    ],
  },
  {
    title: 'Telco, Media and Technology',
    icon: 'fa-solid fa-tower-broadcast',
    description: 'Power next-generation connectivity, content platforms, and digital experiences for telecom and media leaders.',
    challenges: [
      'Modernizing legacy network and billing systems',
      'Delivering new digital services and content platforms',
      'Improving network operations efficiency',
    ],
    solutions: [
      'Cloud-native developers for network and digital platform modernization',
      'DevOps engineers for automated network operations',
      'Data specialists for customer and network analytics',
    ],
  },
  {
    title: 'Travel, Transportation and Logistics',
    icon: 'fa-solid fa-plane',
    description: 'Optimize fleet operations, booking platforms, and logistics networks with real-time data solutions.',
    challenges: [
      'Improving supply chain visibility and real-time tracking',
      'Modernizing legacy booking and operations systems',
      'Delivering seamless customer experiences across channels',
    ],
    solutions: [
      'Backend and API developers for booking and tracking platforms',
      'Cloud engineers for scalable logistics infrastructure',
      'Data specialists for predictive logistics analytics',
    ],
  },
  {
    title: 'AI-Powered CCTV Surveillance',
    icon: 'fa-solid fa-video',
    description: 'Turn CCTV footage into real-time safety alerts and actionable insights with AI-powered surveillance.',
    challenges: [
      'Relying on manual monitoring to catch safety violations and security incidents',
      'Reviewing hours of footage after an incident instead of preventing it',
      'Scaling surveillance oversight across multiple sites and cameras',
    ],
    solutions: [
      'Computer vision engineers for real-time video analytics',
      'AI/ML specialists for anomaly and violation detection',
      'Cloud engineers for scalable, multi-site video infrastructure',
    ],
  },
  {
    title: 'E-Commerce',
    icon: 'fa-solid fa-cart-shopping',
    description: 'Build and scale high-converting online stores with modern, secure e-commerce platforms.',
    challenges: [
      'Delivering fast, reliable storefronts that convert across devices',
      'Integrating payments, inventory, and fulfillment into one seamless flow',
      'Scaling platforms to handle traffic spikes during sales and promotions',
    ],
    solutions: [
      'Shopify and headless commerce developers for custom storefronts',
      'Backend engineers for payment, inventory, and order management integration',
      'Cloud engineers for scalable, high-availability e-commerce infrastructure',
    ],
  },
  {
    title: 'Marketing & Sales Tracking',
    icon: 'fa-solid fa-bullseye',
    description: 'Track marketing performance and sales pipelines with unified analytics that drive smarter growth decisions.',
    challenges: [
      'Marketing and sales data scattered across disconnected tools and spreadsheets',
      'Limited visibility into campaign ROI and pipeline conversion',
      'Manual reporting that slows down data-driven decision-making',
    ],
    solutions: [
      'Data engineers to unify marketing and CRM data into a single source of truth',
      'Analytics specialists for campaign attribution and sales funnel dashboards',
      'AI/ML developers for lead scoring and revenue forecasting',
    ],
  },
];

function IndustryCard({ industry }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <article id={slugify(industry.title)} className={`industry-card${isExpanded ? ' is-expanded' : ''}`}>
      <div className="industry-card-icon" aria-hidden="true">
        <i className={industry.icon}></i>
      </div>
      <h3>{industry.title}</h3>
      <p>{industry.description}</p>
      <button
        type="button"
        className="industry-card-toggle"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((expanded) => !expanded)}
      >
        {isExpanded ? 'Hide Details' : 'Read More'}
        <i className={`fa-solid ${isExpanded ? 'fa-arrow-up' : 'fa-arrow-right'}`} aria-hidden="true"></i>
      </button>
      {isExpanded && (
        <div className="industry-card-details">
          <h4>Industry Challenges</h4>
          <ul>
            {industry.challenges.map((challenge) => <li key={challenge}>{challenge}</li>)}
          </ul>
          <h4>How We Help</h4>
          <ul>
            {industry.solutions.map((solution) => <li key={solution}>{solution}</li>)}
          </ul>
        </div>
      )}
    </article>
  );
}

export default IndustryCard;
